import { toast } from '@systemeio/ui'
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { NewsletterViewApiInterface } from 'modules/newsletters/single/types/newsletter-view-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const useDuplicateNewsletter = () => {
  const { t } = useLocoTranslation()
  const { fetcher } = useFetch<RequestMethodsEnum.post, NewsletterViewApiInterface>({
    method: RequestMethodsEnum.post,
  })

  return async (id: NewsletterId) => {
    try {
      const res = await fetcher(`${NEWSLETTERS_API}/duplicate/${id}`)
      toast.success(t('dashboard.newsletter_editor.was_duplicated_message'))
      return res
    } catch (e) {
      throw e
    }
  }
}
